import React, { useState } from 'react';
import { Sheet } from 'tamagui';
import { CobuStack, CobuText, CobuView } from '@cobu/ui';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Strings } from '../../constants/Strings';

type Props = {
  onReportPress: () => void;
};

/**
 * The place detail screen's "⋯" overflow menu — mirrors events'
 * CreatorMenuButton (tap → action-sheet with Cancel), trimmed to the one
 * action Places currently needs.
 */
export default function PlaceMenuButton({ onReportPress }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <CobuStack
        role="button"
        tabIndex={0}
        onPress={() => setOpen(true)}
        ai="center"
        jc="center"
        w="$6"
        h="$6"
        br="$4"
        bg="transparent"
        style={{ cursor: 'pointer' }}
      >
        <MoreHorizIcon fontSize="small" />
      </CobuStack>

      {open ? (
        <Sheet
          open
          onOpenChange={(next: boolean) => {
            if (!next) setOpen(false);
          }}
          snapPoints={[160]}
          snapPointsMode="constant"
          dismissOnSnapToBottom
          dismissOnOverlayPress
          modal
        >
          <Sheet.Overlay
            animation={undefined as any}
            enterStyle={{ o: 0 }}
            exitStyle={{ o: 0 }}
            bg="$blackTransparent50"
          />
          <Sheet.Handle />
          <Sheet.Frame>
            <CobuStack py="$3" gap="$2">
              <ActionItem
                label={Strings.get().places.report.menuLabel}
                color="$red"
                onPress={() => {
                  setOpen(false);
                  onReportPress();
                }}
              />
              <CobuStack h={1} bg="$borderColor" mx="$2" />
              <ActionItem label={Strings.get().places.report.cancel} onPress={() => setOpen(false)} />
            </CobuStack>
          </Sheet.Frame>
        </Sheet>
      ) : null}
    </>
  );
}

function ActionItem({ label, onPress, color }: { label: string; onPress: () => void; color?: string }) {
  return (
    <CobuView onPress={onPress}>
      <CobuStack layout="horizontal" ai="center" jc="center" gap="$3" p="$3" br="$2" hoverStyle={{ background: '$backgroundMuted' }}>
        <CobuText variant="body" fos="$3" fow="500" color={color as any}>
          {label}
        </CobuText>
      </CobuStack>
    </CobuView>
  );
}
